import { motion } from "framer-motion";
import { Crosshair, Scissors, Brain, TrendingUp, ShieldAlert, Clapperboard } from "lucide-react";
import { MEDIA } from "./media";

export function FeaturesBento() {
    return (
        <section id="features" className="py-24 md:py-32" data-testid="features-bento">
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="max-w-2xl mb-12">
                    <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-volt mb-3">The Arsenal</p>
                    <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-white">
                        Everything a pro coach does — automatically, every match.
                    </h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
                    <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
                        className="group md:col-span-7 md:row-span-2 rounded-sm border border-white/10 bg-surface hover:border-volt/40 transition-colors p-6 relative overflow-hidden">
                        <Crosshair className="w-7 h-7 text-volt mb-4" />
                        <h3 className="font-heading text-xl font-bold text-white mb-2">Real-Time Tactical Coach</h3>
                        <p className="text-sm text-muted-foreground max-w-md">
                            Jarvis-style callouts the moment a threat appears — "Enemy, 3 o'clock, close." Positioning, awareness
                            and fight advice spoken in your ear while you play, with zero anti-cheat risk.
                        </p>
                        <img src={MEDIA.hud} alt="Tactical HUD callouts" className="mt-6 w-full rounded-sm border border-white/10 opacity-90 group-hover:opacity-100 transition-opacity" />
                    </motion.div>

                    <Feature icon={Scissors} className="md:col-span-5" title="Auto-Clip Highlights" desc="Every clutch, multi-kill and key moment saved automatically — no scrubbing footage." />
                    <Feature icon={Brain} className="md:col-span-5" title="AI Match Analysis" desc="Crosshair, positioning, movement and decisions graded after every game with a rating." />
                    <Feature icon={TrendingUp} className="md:col-span-4" title="Improvement Tracking" desc="A 7-axis skill radar and trends show exactly where you're climbing." />
                    <Feature icon={ShieldAlert} className="md:col-span-4" title="Anomaly & Evidence" desc="Flags unusual encounters and packages timeline evidence — never accuses." />
                    <Feature icon={Clapperboard} className="md:col-span-4" title="Content Studio" desc="AI titles, captions, hashtags and highlight reels for YouTube, TikTok & X." />
                </div>
            </div>
        </section>
    );
}

function Feature({ icon: Icon, title, desc, className = "" }) {
    return (
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
            className={`rounded-sm border border-white/10 bg-surface hover:border-volt/40 transition-colors p-6 ${className}`}>
            <Icon className="w-6 h-6 text-volt mb-3" />
            <h3 className="font-heading text-lg font-bold text-white mb-1.5">{title}</h3>
            <p className="text-sm text-muted-foreground">{desc}</p>
        </motion.div>
    );
}
